.card {
  border-style: solid;
  border-radius: 8px;
  cursor: pointer;
  padding: 16px;
}

.cardHeader {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 8px;
}
